var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSandboxEcosystem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 43,
    viewBox: "0 0 144 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3315 6.26147H75.499V5.74812L74.9856 5.17773H72.3048L71.7344 5.74812V9.96899L72.3048 10.5394H74.9856L75.499 9.96899V9.45564H73.3315V8.3719H75.499V7.34521H73.3315V6.26147Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1559 0.443359H72.1328V3.46641H75.1559V0.443359Z",
    fill: "#3BBFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2821 5.17773V7.34521H67.685V5.17773H66.6012L66.0879 5.74812V9.96899L66.6012 10.5394H67.685V8.3719H69.2821V10.5394H70.3088L70.8792 9.96899V5.74812L70.3088 5.17773H69.2821Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8962 5.17773L60.3828 5.74812V6.26147H61.9799V9.96899L62.4933 10.4823H63.0637L63.577 9.96899V6.26147H65.1741V5.74812L64.6608 5.17773H60.8962Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4395 12.3643V33.6397H75.3838L77.4943 31.5293V14.5317L75.3838 12.4213H60.4395V12.3643ZM66.8279 16.6422H71.1059V29.4188H66.8279V16.6422Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6582 12.3643V33.6397H94.6026L96.713 31.5293V25.1409L94.6026 23.0305L96.713 20.9201V14.5317L94.6026 12.4213H79.6582V12.3643ZM86.0466 25.1409H90.3246V29.4188H86.0466V25.1409ZM86.0466 20.863V16.5851H90.3246V20.863H86.0466Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 12.3643L98.9414 14.4747V31.4722L101.052 33.5827H113.886L115.996 31.4722V14.4747L113.886 12.3643H101.052ZM105.33 16.6422H109.608V29.4188H105.33V16.6422Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.221 22.9742L139.213 18.9814L143.263 22.9742L139.213 27.0239L135.221 22.9742Z",
    fill: "#3BBFF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.772 12.3643V18.6956L126.661 20.863L124.494 18.6956V12.3643H120.273L118.105 14.4747V20.863L120.273 22.9735L118.105 25.0839V31.4722L120.273 33.5827H124.494V27.2514L126.661 25.0839L128.772 27.2514V33.5827H133.05L135.217 31.4722V25.0839L133.05 22.9735L135.217 20.863V14.4747L133.05 12.3643H128.772Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9433 12.3633V18.6946L45.4978 12.3633H41.2198L39.1094 14.4737V31.4713L41.2198 33.5817H45.4978V20.8621L51.9433 27.2504V33.5817H56.2213L58.3317 31.4713V14.4737L56.2213 12.3633H51.9433Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8311 12.3643H21.9972L19.8867 14.4747V31.4722L21.9972 33.5827H26.2752V25.0839H30.5531V33.5827H34.8311L36.9416 31.4722V14.4747L34.8311 12.3643ZM28.4427 21.6616L25.7048 18.9237L28.4427 16.1859L31.1806 18.9237L28.4427 21.6616Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77453 12.3633L0.664062 14.4737V22.9725L2.77453 25.0829H11.3305V29.3608H7.0525V27.2504H0.664062V31.4713L2.77453 33.5817H15.6084L17.7759 31.4713V22.9725L15.6084 20.8621H7.0525V16.5841H11.3305V18.6946H17.7759V14.4737L15.6084 12.3633H2.77453Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3359 38.7734L28.3287 34.7236L32.3785 38.7734L28.3287 42.7661L24.3359 38.7734Z",
    fill: "#3BBFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandboxEcosystem);
export default __webpack_public_path__ + "static/media/sandbox-ecosystem.202b542f7b7b58cb5eb50237e510e1d5.svg";
export { ForwardRef as ReactComponent };